import type { ElementType } from "react";

import { cx, styled } from "simplydo/react/styled";

import type { CardHeaderProps } from "./Card.types";

const HeaderEl = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: #000;
`;

const CardHeaderComponent = (props: CardHeaderProps) => {
  const { as, children, className, style } = props;
  const Tag = (as || "div") as ElementType;
  return (
    <HeaderEl as={Tag} className={cx(className)} style={style}>
      {children}
    </HeaderEl>
  );
};

export const CardHeader = styled(CardHeaderComponent)``;
